import { Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { LIVE_ROOM_ANCHOR } from '~/features/events/components/event-announcement-card'
import * as m from '~/paraglide/messages'
import { cn } from '~/shared/lib/utils'
import type { Event } from '~/shared/types'
import { buttonVariants } from '~/shared/ui/button'

export function LiveNowBar({ event, locale }: { event: Event; locale: string }) {
  const withRoom = event.liveRoomMode !== 'off'
  const until = new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: '2-digit' }).format(
    new Date(event.endTime),
  )
  const action = withRoom ? m.overviewLiveOpenRoom() : m.overviewLiveOpenEvent()

  return (
    <Link
      to="/dashboard/events/$eventId"
      params={{ eventId: event.id }}
      hash={withRoom ? LIVE_ROOM_ANCHOR : undefined}
      className="group flex items-center gap-3 rounded-full border border-border bg-card py-1.5 pr-1.5 pl-2 outline-none transition-colors duration-150 ease-spring hover:border-foreground/20 focus-visible:ring-[3px] focus-visible:ring-ring/50"
    >
      <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-brand-subtle px-2.5 py-1 font-semibold text-brand-subtle-foreground text-xs">
        <span aria-hidden className="size-1.5 rounded-full bg-current" />
        {m.overviewLiveNow()}
      </span>
      <span className="flex min-w-0 flex-1 items-baseline gap-2">
        <span className="min-w-0 truncate font-medium text-foreground text-sm">{event.title}</span>
        <span className="hidden shrink-0 text-muted-foreground text-xs sm:inline">
          {m.overviewLiveUntil({ time: until })}
        </span>
      </span>
      <span
        className={cn(
          buttonVariants({ size: 'sm' }),
          'shrink-0 px-2.5 group-hover:bg-foreground/85 sm:px-3',
        )}
      >
        <span className="sr-only sm:not-sr-only">{action}</span>
        <ArrowRight aria-hidden />
      </span>
    </Link>
  )
}
